export default __webpack_public_path__ + "static/media/reviewPage@2x.357ca9b5.png";